<template>
    <div class="pullPage">
        <Tabs :tabs="detailTbs" :activeCom.sync="Dactive" />
        <div class="detailMsg">
            <BaseList :detailObj="detailObj" :baseMsg="baseMsg" :isMode="isMode" ref="BaseList" v-bind="$attrs" @modeChanges="modeChanges" @saveDecFn="confrimFn" />
            <Upload :Upload="Upload" :isMode="isMode" ref="upload" />
            <changeIcon :isMode="isMode" @modeChange="modeChange" />
        </div>
        <Tabs :tabs="tabsArray" :activeCom.sync="TabsActive" @handleTabs="handleTabs" />
        <keep-alive>
            <component :is="TabsActive" :detailNetObj="netObj" v-bind="$attrs" />
        </keep-alive>
        <div class="bottom_btn">
            <el-button type="primary" @click="closeFn">{{ $t('buttonTitle.Close') }}</el-button>
        </div>
    </div>
</template>

<script>
import Tabs from '@/pages/equipment/publicCom/Tabs.vue';
import Application from '@/pages/equipment/publicCom/Application.vue';
import NetParam from '@/pages/equipment/publicCom/NetParam.vue';
import changeIcon from '@/pages/equipment/publicCom/changeIcon.vue';
import Upload from '@/pages/equipment/publicCom/Upload.vue';
import BaseList from './component/BaseList.vue';
import resultHandle from '@/common/resultHandle';
import { relayUpdateRelay } from '@/api/modules/relay.js';
export default {
    props: ['detailNetObj', 'detailObj'],
    components: {
        Tabs,
        BaseList,
        Application,
        NetParam,
        Upload,
        changeIcon
    },
    watch: {
        detailRuleObj(newVal) {
            this.appObj.forEach(item => {
                item.content = newVal[item.key];
            });
        },
        detailNetObj(newVal) {
            console.log(this.$attrs);
            this.netObj.forEach(item => {
                item.content = newVal[item.key];
            });
        }
    },
    data() {
        return {
            isMode: false,
            detailTbs: [
                {
                    name: 'Detail',
                    label: 'public.detail_info'
                }
            ],
            Dactive: 'Detail',
            // 设备tabs
            tabsArray: [
                {
                    name: 'Application',
                    label: 'public.attribute'
                },
                {
                    name: 'NetParam',
                    label: 'public.net_param'
                }
            ],
            TabsActive: 'Application',
            // 图片
            Upload: {},
            baseMsg: [
                {
                    text: 'public.belong',
                    key: 'url'
                },
                {
                    text: $t('integration.trunk_number'),
                    key: 'relay_code'
                },
                {
                    text: $t('integration.relay_nickname'),
                    key: 'nickname'
                },
                {
                    text: 'device.config_status',
                    key: 'configStatus'
                },
                {
                    text: $t('integration.mount_'),
                    key: 'carrierName'
                },
                {
                    text: $t('integration.relay_type'),
                    key: 'type'
                },
                {
                    text: 'public.table_create_time',
                    key: 'create_time'
                },
                {
                    text: $t('integration.update_time'),
                    key: 'stop_time'
                },

                {
                    text: $t('public.table_desc'),
                    key: 'description'
                }
            ],
            appObj: [
                {
                    text: $t('integration.alarm_or_not'),
                    key: 'alarmOn',
                    content: '123'
                },
                {
                    text: $t('integration.duration_(seconds)'),
                    key: 'alarmInterval',
                    content: '123'
                },
                {
                    text: $t('integration.interval_time_(seconds)'),
                    key: 'alarmPeriod',
                    content: '123'
                }
            ],
            netObj: [
                {
                    text: 'ext Pan Id',
                    key: 'extPanId',
                    content: '123'
                },
                {
                    text: 'Join Attemp',
                    key: 'channelPage',
                    content: '123'
                },
                {
                    text: 'device.transmit_power',
                    key: 'transmitPower',
                    content: '123'
                },
                {
                    text: 'device.channel_mask',
                    key: 'channelMask',
                    content: '123'
                },
                {
                    text: 'device.in_net_interval',
                    key: 'inNetInterval',
                    content: '123'
                }
            ],
            description: '',
            isEdit: true
        };
    },
    mounted() {
        if (this.$attrs['sensorWay'] !== 'bind' && this.$attrs['sensorWay'] !== 'stop') {
            this.baseMsg.splice(4, 1);
        }
    },
    methods: {
        closeFn() {
            window.close();
        },
        modeChange() {
            this.isMode = !this.isMode;
        },
        modeChanges(row) {
            this.isMode = !this.isMode;
            this.$parent.detailFn(row);
        },
        handleTabs(name) {
            this.TabsActive = name;
        },
        handleEdit() {
            this.isEdit = !this.isEdit;
        },
        confrimFn(row) {
            const { imageSuffix, imageUrl } = this.$refs['upload'].newUpload;
            const { id, is_heart, nickname, areaValue } = row;

            relayUpdateRelay({
                id,
                is_heart,
                nickname,
                description: areaValue,
                uploadFileBase64: imageUrl,
                uploadFileSuffix: imageSuffix
            }).then(async ({ state }) => {
                await resultHandle(state);

                this.isEdit = !this.isEdit;
                this.isMode = !this.isMode;

                this.$parent.detailFn(this.detailObj);
                this.$parent.getListFn();
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.detailMsg {
    display: flex;
}

.pullPage {
    height: 100%;
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    .bottom_btn {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 50px;
        border-top: 1px solid #e7e7e7;
        line-height: 50px;
        text-align: center;

        button {
            margin: 0 10px;
        }
    }
}
</style>
